import React from "react";
import { IEventSummary, IScore, IShow } from "@eagerdog/interfaces";

import { NestedSection } from "./NestedSection";
import { GroupAwardsCard } from "./GroupAwardsCard";
import { sortGroups } from "./partitionScores";

interface IProps {
  scores: IScore[];
  event: IEventSummary;
  show: IShow;
  onSaved: () => void;
}

export const GroupsPanel: React.FC<IProps> = ({ scores, event, show, onSaved }) => {
  if (!scores.length) return null;
  const byGroup = new Map<string, IScore[]>();
  scores.forEach((score) => {
    const group = score.breed_group || "Unknown";
    if (!byGroup.has(group)) byGroup.set(group, []);
    byGroup.get(group)!.push(score);
  });
  const groups = sortGroups(Array.from(byGroup.keys()));

  return (
    <NestedSection title="Groups" meta="Regular">
      {groups.map((group) => (
        <GroupAwardsCard
          key={group}
          breedGroup={group}
          scores={byGroup.get(group) || []}
          event={event}
          show={show}
          onSaved={onSaved}
        />
      ))}
    </NestedSection>
  );
};
